//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('colorGrps', {
//        templateUrl: 'views/components/views/colorGrps/colorGrps.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'colorGrpsService', function (stateService, colorGrpsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                filterValueButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.filterval = '' }
//                ],
//                setting: {},
//                itemsListViews: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTIONS

//            async function loadSetting() {
//                vm.model.setting = (await colorGrpsService.getSetting())[0];
//            }

//            async function loadColourGroupViews() {
//                vm.model.itemsListViews = await colorGrpsService.listColourGroupViews();
//            }

//            // #endregion LOAD PROCEDURE FUNCTIONS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'colorgrp':
//                        go({ colorgrp_id: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadSetting();
//                loadColourGroupViews();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
